// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"Profile_profileWrapper__33ZbR","headerWrapper":"Profile_headerWrapper__2_RTV"};